import React from 'react';
import clsx from 'clsx';
import styles from '../OrderStatus.module.css';
import HelpfulInfo from '../HelpfulInfo';
import OrderDetails from '../OrderDetails';
import ProductsDetails from '../ProductsDetails';
import ShippingDetails from '../ShippingDetails';
import CoreReturnsDetails from '../CoreReturnsDetails';
import DamageClaimsDetails from '../DamageClaimsDetails';
import ServicerList from '../../FindAServicer/ServicerList';
import { useScreenSize } from '../../../hooks/useScreenSize';
import buttonStyles from '../../../styles/buttons.module.css';
import ReturnAuthorizationsDetails from '../ReturnAuthorizationsDetails';
import OrderManagementRequestForm from '../../forms/OrderManagementRequestForm';
import BillingDetails from '../BillingDetails';
import BillingInfoForm from '../../forms/BillingInfoForm';
import Render from '../../Render';

const FullDetails = (props) => {
  
  const [openOrderManagement, setOpenOrderManagement] = React.useState(false);
  const [formSubmitted, setFormSubmitted] = React.useState(false);

  const [openCreditCardForm, setOpenCreditCardForm] = React.useState(false);

  const { breakAt } = useScreenSize();
  const small = !breakAt('sm')

  const isTmdOrder = props.order.purchase_site === 'TMD';
  const displayOrderNumber = (isTmdOrder && props.order.external_purchase_id)
    ? props.order.external_purchase_id
    : props.order.purchase_id;
  const thankYouSite = isTmdOrder ? 'TreadmillDoctor.com' : 'FitnessRepairParts.com';

  const raEligibility = props.order.ra_eligibility.customer ||
    props.order.ra_eligibility.edit_ra_45 ||
    props.order.ra_eligibility.edit_ra_90 ||
    props.order.ra_eligibility.edit_ra_180;

  function handleManageOrderOpen() {
    setFormSubmitted(false);
    setOpenOrderManagement(true);
  }

  function handleCreditCardFormOpen() {
    setOpenCreditCardForm(true);
  }

  return (
    <>
      <p style={{ margin: 0 }}>
        <strong>Thank you for shopping with {thankYouSite}.</strong>{small && <br />} We recommend creating
        a free account to earn volume discounts, view purchase history, and more.<br />
      </p>
      <div className='row'>
        <div className={clsx('col-sm-10', styles.informationContainer)}>
          <h1 style={{ margin: 0, textAlign: 'left', fontSize: 24 }}>Order #{displayOrderNumber}</h1>
        </div>
        <div className={clsx('col-sm', styles.informationContainer)}>
          <a href={'/admin_pop_order.php?action=invoice&purchase_id='+ props.order.purchase_id + '&key=' + props.validators.token} target='_blank' style={{paddingLeft: '8%'}}>Print Invoice</a>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12' style={{ paddingTop: 10 }}>
          {(props.order.purchase_status !== 'shipped' && props.order.purchase_status !== 'cancelled') && <button className={buttonStyles.cancelButton} onClick={handleManageOrderOpen}>Manage Order</button>}
        </div>
      </div>
      <div className='row'>
        <div className={clsx('col-md-6', styles.informationContainer)}>
          <OrderDetails
            order={props.order}
          />
        </div>
        <div className={clsx('col-md-6', styles.informationContainer)}>
          <ShippingDetails
            order={props.order}
            trackingNumbers={props.trackingNumbers}
          />
        </div>
      </div>
      <div className='row'>
        <div className={clsx('col-md-6', styles.informationContainer)}>
          <Render if={props.order.purchase_payment_type == 'credit card'}>
            <BillingDetails 
              order={props.order}
              creditCard={props.creditCard}
              getCreditCardUsedOnOrderMeta={props.getCreditCardUsedOnOrderMeta}
            />
          </Render>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12' style={{ paddingTop: 5 }}>
          {(props.order.purchase_status == 'card declined' && !props.getCreditCardUsedOnOrderMeta.loading) && 
            <button 
              className={buttonStyles.cancelButton} 
              onClick={handleCreditCardFormOpen}
            >
              Edit Billing Info
            </button>}
        </div>
      </div>
      <div className='row'>
        <div className={clsx('col-md-12', styles.informationContainer)}>
          <ProductsDetails
            products={props.products}
            purchaseStatus={props.order.purchase_status}
          />
        </div>
      </div>
      {(props.returnAuthorizations?.length > 0 || raEligibility) &&
        <div className='row'>
          <div className={clsx('col-md-12', styles.informationContainer)}>
            <ReturnAuthorizationsDetails
              returnAuthorizations={props.returnAuthorizations}
              order={props.order}
              validators={props.validators}
              raEligibility={raEligibility}
            />
          </div>
        </div>
      }
      {props.damageClaims?.length > 0 &&
        <div className='row'>
          <div className={clsx('col-md-12', styles.informationContainer)}>
            <DamageClaimsDetails
              damageClaims={props.damageClaims}
              validators={props.validators}
            />
          </div>
        </div>
      }
      {props.coreReturns?.length > 0 &&
        <div className='row'>
          <div className={clsx('col-md-12', styles.informationContainer)}>
            <CoreReturnsDetails
              coreReturns={props.coreReturns}
              shippingZip={props.order.purchase_ship_zip}
            />
          </div>
        </div>
      }
      <div className='row'>
        <div className={clsx('col-md-12', styles.informationContainer)}>
          <h2 className={styles.heading}>Service Centers Near You</h2>
          <ServicerList
            loading={props.servicersLoading}
            servicers={props.servicers}
            type='zip'
          />
        </div>
      </div>
      <div className='row'>
        <div className={clsx('col-md-12', styles.informationContainer)}>
          <HelpfulInfo />
        </div>
      </div>
      <OrderManagementRequestForm 
        submitForm={props.submitOrderManagementForm}
        modifyOrderMeta={props.modifyOrderMeta}
        setFormSubmitted={setFormSubmitted}
        formSubmitted={formSubmitted}
        openOrderManagement={openOrderManagement}
        setOpenOrderManagement={setOpenOrderManagement}
      />
      <BillingInfoForm
        states={props.states}
        creditCard={props.creditCard}
        purchaseCardAddressBlock={props.order.purchase_card_address_block}
        creditCardResponse={props.creditCardResponse}
        updateCreditCardMeta={props.updateCreditCardMeta}
        submitCreditCardChangeForm={props.submitCreditCardChangeForm}
        openCreditCardForm={openCreditCardForm}
        setOpenCreditCardForm={setOpenCreditCardForm}
      />
    </>
  );
};

export default FullDetails;